import { Subject } from "rxjs";

const subject = new Subject();

export const PriceWatcherMessageService = {
  sendMessage: message => subject.next(message),
  clearMessages: () => subject.next(),
  getMessage: () => subject.asObservable()
};
